import { Box } from '@mui/material'
import styled from 'styled-components'

export const SuccessFactorIndicatorsStyled = styled(Box)`
  flex: 1 0 28%;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex: 1 0 100%;
  }

  &:first-child:nth-last-child(4),
  &:first-child:nth-last-child(4) ~ & {
    flex: 1 0 42%;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      flex: 1 0 100%;
    }
  }

  .indicator-title {
    color: ${({ theme }) => theme.colors.text.disabled};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  hr {
    margin-block: ${({ theme }) => theme.spacing(1)};
  }

  .html-renderer {
    color: ${({ theme }) => theme.colors.text.secondary};

    ul {
      padding-inline-start: ${({ theme }) => theme.spacing(2)};
      margin-top: ${({ theme }) => theme.spacing(1)};

      li::marker {
        color: ${({ theme }) => theme.colors.text.secondary};
      }
    }
  }
`
